"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// @index('./*.ts', pp => `import { ${pp.name} } from '${pp.path}';`)
var EntityRisksTableShortcut_1 = require("./EntityRisksTableShortcut");
exports.EntityRisksTableShortcut = EntityRisksTableShortcut_1.EntityRisksTableShortcut;
var FundShortcut_1 = require("./FundShortcut");
exports.FundShortcut = FundShortcut_1.FundShortcut;
var FundsShortcut_1 = require("./FundsShortcut");
exports.FundsShortcut = FundsShortcut_1.FundsShortcut;
var PortfolioCompositeFundShortcut_1 = require("./PortfolioCompositeFundShortcut");
exports.PortfolioCompositeFundShortcut = PortfolioCompositeFundShortcut_1.PortfolioCompositeFundShortcut;
var PortfolioCorrelationShortcut_1 = require("./PortfolioCorrelationShortcut");
exports.PortfolioCorrelationShortcut = PortfolioCorrelationShortcut_1.PortfolioCorrelationShortcut;
var PortfoliosBarChartDataShortcut_1 = require("./PortfoliosBarChartDataShortcut");
exports.PortfoliosBarChartDataShortcut = PortfoliosBarChartDataShortcut_1.PortfoliosBarChartDataShortcut;
var PortfolioShortcut_1 = require("./PortfolioShortcut");
exports.PortfolioShortcut = PortfolioShortcut_1.PortfolioShortcut;
var PortfoliosMptStatisticsShortcut_1 = require("./PortfoliosMptStatisticsShortcut");
exports.PortfoliosMptStatisticsShortcut = PortfoliosMptStatisticsShortcut_1.PortfoliosMptStatisticsShortcut;
var PortfoliosScatterChartDataShortcut_1 = require("./PortfoliosScatterChartDataShortcut");
exports.PortfoliosScatterChartDataShortcut = PortfoliosScatterChartDataShortcut_1.PortfoliosScatterChartDataShortcut;
var PortfoliosShortcut_1 = require("./PortfoliosShortcut");
exports.PortfoliosShortcut = PortfoliosShortcut_1.PortfoliosShortcut;
var ShortcutBase_1 = require("./ShortcutBase");
exports.ShortcutBase = ShortcutBase_1.ShortcutBase;
//# sourceMappingURL=index.js.map